export abstract class SystemBase {



    abstract update(time: number, delta: number): void;

    abstract endOfFrame(): void;

}